import PageContent from './components/PageContent'

const TeamOverview = () => (
  <PageContent />
)

export default TeamOverview
